import { FC } from 'react';
import { IconColor, IIcon } from './type';

export const ArrowRightIcon: FC<IIcon> = ({
  width = 32,
  height = 32,
  fill = IconColor.WHITE,
  className,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <path
      d="M12.2178 22.3C12.0844 22.1222 12.0122 21.9333 12.0011 21.7333C11.99 21.5333 12.0622 21.3556 12.2178 21.2L18.1511 15.2667L12.2178 9.33333C12.0622 9.2 11.99 9.02222 12.0011 8.8C12.0122 8.57778 12.0844 8.38889 12.2178 8.23333C12.3956 8.07778 12.5789 8 12.7678 8C12.9567 8 13.1289 8.07778 13.2844 8.23333L19.6511 14.6C19.7622 14.7111 19.84 14.8167 19.8844 14.9167C19.9289 15.0167 19.9511 15.1333 19.9511 15.2667C19.9511 15.4 19.9289 15.5222 19.8844 15.6333C19.84 15.7444 19.7622 15.8556 19.6511 15.9667L13.3178 22.3C13.1622 22.4556 12.9844 22.5278 12.7844 22.5167C12.5844 22.5056 12.3956 22.4333 12.2178 22.3Z"
      fill={fill}
    />
  </svg>
);
